const upsertMeta = (selector, attrs) => {
  let tag = document.querySelector(selector);
  if (!tag) {
    tag = document.createElement("meta");
    document.head.appendChild(tag);
  }
  Object.entries(attrs).forEach(([key, value]) => tag.setAttribute(key, value));
  return tag;
};

const upsertLink = (rel, href) => {
  if (!href) return;
  let tag = document.querySelector(`link[rel="${rel}"]`);
  if (!tag) {
    tag = document.createElement("link");
    tag.setAttribute("rel", rel);
    document.head.appendChild(tag);
  }
  tag.setAttribute("href", href);
};

const upsertJsonLd = (id, data) => {
  if (!data) return;
  let tag = document.getElementById(id);
  if (!tag) {
    tag = document.createElement("script");
    tag.id = id;
    tag.type = "application/ld+json";
    document.head.appendChild(tag);
  }
  tag.textContent = JSON.stringify(data);
};

export const setPageMeta = ({
  title,
  description,
  keywords,
  canonical,
  robots,
  og = {},
  twitter = {},
  jsonLd,
  jsonLdId = "page-json-ld",
  removeJsonLdIds = [],
}) => {
  if (title) document.title = title;
  if (description) upsertMeta('meta[name="description"]', { name: "description", content: description });
  if (keywords) upsertMeta('meta[name="keywords"]', { name: "keywords", content: keywords });
  if (robots) upsertMeta('meta[name="robots"]', { name: "robots", content: robots });
  if (canonical) upsertLink("canonical", canonical);
  Object.entries(og).forEach(([property, content]) => {
    if (content) upsertMeta(`meta[property="og:${property}"]`, { property: `og:${property}`, content });
  });
  Object.entries(twitter).forEach(([name, content]) => {
    if (content) upsertMeta(`meta[name="twitter:${name}"]`, { name: `twitter:${name}`, content });
  });
  removeJsonLdIds.forEach((id) => document.getElementById(id)?.remove());
  if (jsonLd) upsertJsonLd(jsonLdId, jsonLd);
};
